import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons'

import './Player.css';
import Cart from '../Cart/Cart';
 

const Player = (props) => {
    const {image,name,country,salary}=props.player;
    
    return (
      
        
        <div className="player">
            <div className="player-img">
                <img src={image} alt=""/>
            </div>
         <div className="player-name"> 
            <h3> Player Name : {name}</h3>
            <h4> Country : {country}</h4>
            <h6>Salary: {salary} USD</h6>
             
          
          
            
            
            <div>
         
        
        <button type="button" className="btn btn-success" onClick= {() => props.handleAddPlayers(props.player)}><FontAwesomeIcon icon={faPlusCircle} /> Select Player</button>
         </div> </div>
         
         
         
         
            
        </div>
        
        
    );
};

export default Player;